var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12202 2452",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.265.011a.237.237 0 0 1-.122-.029.182.182 0 0 1-.074-.083.355.355 0 0 1-.028-.135l.127-.025a.388.388 0 0 0 .011.083.129.129 0 0 0 .029.056.071.071 0 0 0 .052.019c.024 0 .041-.007.051-.021a.096.096 0 0 0 .015-.055.149.149 0 0 0-.024-.087.44.44 0 0 0-.064-.068l-.102-.09a.296.296 0 0 1-.069-.082.242.242 0 0 1-.025-.113c0-.064.019-.114.056-.148a.217.217 0 0 1 .153-.052c.038 0 .07.006.095.017a.153.153 0 0 1 .06.049c.015.02.027.044.034.07a.433.433 0 0 1 .014.084l-.126.022A.607.607 0 0 0 .32-.645a.104.104 0 0 0-.023-.047C.286-.704.269-.709.248-.709c-.022 0-.039.007-.05.021a.084.084 0 0 0-.018.054c0 .028.006.05.017.068a.332.332 0 0 0 .049.054l.101.089a.42.42 0 0 1 .085.098.25.25 0 0 1 .036.137.204.204 0 0 1-.025.103.177.177 0 0 1-.071.07.217.217 0 0 1-.107.026Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(2954.67353 0 -628.0333 2954.65913 -112.888 2420.079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.061 0v-.81h.238c.049 0 .088.009.118.027a.155.155 0 0 1 .067.078.314.314 0 0 1 .022.125.258.258 0 0 1-.027.127.159.159 0 0 1-.076.071.267.267 0 0 1-.114.022h-.08V0H.061Zm.148-.464h.056a.152.152 0 0 0 .063-.011.064.064 0 0 0 .031-.037.352.352 0 0 0 .002-.141.062.062 0 0 0-.028-.04.149.149 0 0 0-.068-.013H.209v.242Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(2954.67353 0 -628.0333 2954.65913 1506.088 2420.079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.142 0v-.701H.013V-.81h.404v.109H.29V0H.142Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(2954.67353 0 -628.0333 2954.65913 5840.549 2420.079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.142 0v-.701H.013V-.81h.404v.109H.29V0H.142Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(2954.67353 0 -628.0333 2954.65913 7282.56 2420.079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.061 0v-.81h.34v.104H.209v.233H.36v.103H.209v.268h.194V0H.061Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(2954.67353 0 -628.0333 2954.65913 8724.571 2420.079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.061 0v-.81h.194a.43.43 0 0 1 .139.02.164.164 0 0 1 .086.066c.02.032.029.074.029.128A.39.39 0 0 1 .5-.508a.167.167 0 0 1-.03.066.15.15 0 0 1-.06.043L.523 0H.375L.277-.371H.209V0H.061Zm.148-.464h.046a.16.16 0 0 0 .068-.012.08.08 0 0 0 .037-.04.2.2 0 0 0 .011-.071c0-.041-.007-.072-.022-.092-.015-.02-.044-.03-.086-.03H.209v.245Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(2954.67353 0 -628.0333 2954.65913 10148.717 2420.079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.95 578.476c-5.07-22.292-7.75-45.489-7.75-69.306s7.75-69.306 7.75-69.306 18.79 49.074 34.71 69.306c25.37 32.231 60.79 56.184 101.52 67.113a194.01 194.01 0 0 1 28.52-38.567c34.68-36.42 83.44-59.305 137.52-59.876a202.513 202.513 0 0 1 4.46.004 193.98 193.98 0 0 1 31.03 31.326c13.2 16.77 23.68 35.78 30.76 56.363 6.77 19.658 10.45 40.75 10.45 62.694 0 61.624-28.99 116.531-74.05 151.822-19.63 15.368-42.3 27.016-66.96 33.879-33.98-7.344-65.9-20.233-94.77-37.671-71.41-43.126-124.16-114.076-143.19-197.781Zm237.52-2.494c.01-.017.01-.035.02-.052-.04.009-.07.019-.11.028l.09.024Z",
    style: {
      fill: "#bae3e8"
    },
    transform: "matrix(3.93262 0 0 3.9326 -1527.38 -777.371)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1446.04,
    cy: 338.197,
    rx: 119,
    ry: 119.114,
    style: {
      fill: "#fff"
    },
    transform: "matrix(3.93262 0 0 3.9326 -1448.92 -813.529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.1 199.334c.37-.564.47-1.742 1.14-1.676 9.37.93 37.27 3.256 55.11 7.254a309.5 309.5 0 0 1 78.43 29.165c.09 1.201.16 2.41.19 3.627-.42 11.855-5.39 22.56-13.21 30.425-8.24 8.289-19.65 13.424-32.26 13.424-6.55 0-12.79-1.391-18.42-3.892a28.298 28.298 0 0 1 1.05 7.638c0 13.226-9.15 24.332-21.46 27.326a73.012 73.012 0 0 1-29.96-11.586c-19.72-13.209-32.72-35.715-32.72-61.237a73.31 73.31 0 0 1 12.11-40.468Z",
    style: {
      fill: "#bae3e8"
    },
    transform: "matrix(3.93262 0 0 3.9326 -1527.38 -777.371)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.96 234.174c98.06 52.56 164.82 156.044 164.82 274.996 0 22.807-2.45 45.045-7.11 66.464-18.39 84.558-71.13 156.359-142.85 200.032a309.796 309.796 0 0 1-94.33 37.954c-21.74 4.805-44.32 7.339-67.5 7.339-22.67 0-44.78-2.426-66.08-7.031 24.66-6.863 47.33-18.511 66.96-33.879 45.06-35.291 74.05-90.198 74.05-151.822 0-21.944-3.68-43.036-10.45-62.694-7.08-20.583-17.56-39.593-30.76-56.363a193.98 193.98 0 0 0-31.03-31.326c16.45.2 32.4 2.465 47.61 6.547 27.54 7.389 52.66 20.734 73.88 38.566 21.42-22.501 37.46-50.169 46.06-80.932 4.62-16.519 7.09-33.929 7.09-51.912 0-43.511-14.45-83.674-38.81-115.948a207.922 207.922 0 0 0-4.75-6.036c7.82-7.865 12.79-18.57 13.21-30.425a45.072 45.072 0 0 0-.01-3.53Z",
    style: {
      fill: "#fff"
    },
    transform: "matrix(3.93262 0 0 3.9326 -1527.38 -777.371)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a1902123b2d1c952413670537c51dc14.svg";
export { ForwardRef as ReactComponent };